import React, { useState, useEffect } from "react";
import { edmStatusApi, cancelEmailSubscriptionApi, subscribeEmailApi } from "@/api/assistant";
import { useTranslation } from "react-i18next";
import { LoadingOutlined } from "@ant-design/icons";
import { Loading } from "aha-components";

export default function EmailUnsubscribe() {
  const { t } = useTranslation();
  const email = decodeURIComponent(window.location.search.split("email=")[1]);
  const [isSubscribed, setIsSubscribed] = useState(true);
  const [showResult, setShowResult] = useState(false);
  const [statusLoading, setStatusLoading] = useState(true);
  const [unsubscribeLoading, setUnsubscribeLoading] = useState(false);
  const [resubscribeLoading, setResubscribeLoading] = useState(false);

  // 获取邮箱订阅状态
  const getEdmStatus = async () => {
    const resData = await edmStatusApi({ email: email })
    if (resData.code === 0) {
      setIsSubscribed(resData?.data?.subscribed);
    }
    setStatusLoading(false);
  }
  useEffect(() => {
    getEdmStatus();
  }, []);

  // 取消邮箱订阅
  const emailUnsubscribeApi = async () => {
    if (unsubscribeLoading) return;
    setUnsubscribeLoading(true);
    const resData = await cancelEmailSubscriptionApi({ email: email })
    if (resData.code === 0) {
      setIsSubscribed(false);
    }
    setUnsubscribeLoading(false);
  }

  // 订阅邮箱
  const emailResubscribeApi = async () => {
    if (resubscribeLoading) return;
    setResubscribeLoading(true);
    const resData = await subscribeEmailApi({ email: email })
    if (resData.code === 0) {
      setShowResult(true);
    }
    setResubscribeLoading(false);
  }

  if (statusLoading) {
    return (
      <div className="flex flex-col justify-center items-center h-[calc(60vh)] w-full">
        <Loading width={50} height={50} color="#000" strokeWidth={30} />
        <div className="text-gray-500 text-sm">Loading resources...</div>
      </div>
    )
  }

  return (
    <div className="w-full h-[calc(100vh-80px)] flex items-center justify-center">
      {!showResult && isSubscribed && (
      <div className="text-center">
        <div className="w-[926px] text-center justify-center text-neutral-900 text-5xl font-medium font-['Bitter']">{t('emailUnsubscribe.subscribeTitle')}</div>
        <div className="mt-3 text-center justify-center text-neutral-500 text-xl font-normal font-['DM_Sans'] leading-loose">{t('emailUnsubscribe.subscribeDesc')} {atob(email)}</div>
        <div className="mt-8 flex items-center justify-center gap-5">
          <div
            className={`cursor-pointer px-6 h-[40px] rounded-full flex items-center gap-2 bg-gradient-to-b from-white to-[#E7E5E4] hover:bg-white hover:from-white hover:to-white shadow-[0px_1px_3px_0px_rgba(0,0,0,0.10)] w-fit`}
            onClick={() => {
              setShowResult(true);
            }}
          >
            <div
              className="text-center text-[#121212] text-[16px] font-medium font-['Bitter'] leading-tight tracking-tight whitespace-nowrap"
            >
              {t('emailUnsubscribe.button.waitKeepMeSubscribed')}
            </div>
          </div>
          <div 
            className="cursor-pointer rounded-[20px] font-medium"
            style={{
              padding: "8px 20px",
              color: "#FFF",
              background: "linear-gradient(180deg, #3B3D3D 0%, #191A1A 100%)",
              boxShadow: `0px 0px 0px 1px #191A1A08,
              0px 1px 1px -0.5px #191A1A08,
              0px 2px 2px -1px #191A1A08,
              0px 4px 4px -2px #191A1A05,
              0px 8px 8px -4px #191A1A05,
              0px 16px 16px -8px #191A1A05`,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "linear-gradient(180deg, #757575 0%, #414141 100%)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "linear-gradient(180deg, #3B3D3D 0%, #191A1A 100%)";
            }}
            onClick={emailUnsubscribeApi}
            >
              {t('emailUnsubscribe.button.unsubscribe')} 
              {unsubscribeLoading && <LoadingOutlined className="ml-2" />}
            </div>
        </div>
      </div>)}
      {!showResult && !isSubscribed && (
        <div className="text-center">
          <div className="w-[926px] text-center justify-center text-neutral-900 text-5xl font-medium font-['Bitter']">{t('emailUnsubscribe.cancelTitle')}</div>
          <div className="mt-3 text-center justify-center text-neutral-500 text-xl font-normal font-['DM_Sans'] leading-loose">{t('emailUnsubscribe.cancelDesc')}</div>
          <div className="mt-8 flex items-center justify-center gap-5">
          <div 
            className="cursor-pointer rounded-[20px] font-medium"
            style={{
              padding: "8px 20px",
              color: "#FFF",
              background: "linear-gradient(180deg, #3B3D3D 0%, #191A1A 100%)",
              boxShadow: `0px 0px 0px 1px #191A1A08,
              0px 1px 1px -0.5px #191A1A08,
              0px 2px 2px -1px #191A1A08,
              0px 4px 4px -2px #191A1A05,
              0px 8px 8px -4px #191A1A05,
              0px 16px 16px -8px #191A1A05`,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "linear-gradient(180deg, #757575 0%, #414141 100%)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "linear-gradient(180deg, #3B3D3D 0%, #191A1A 100%)";
            }}
            onClick={emailResubscribeApi}
            >
              {t('emailUnsubscribe.button.resubscribe')}
              {resubscribeLoading && <LoadingOutlined className="ml-2" />}
            </div>
          </div>
        </div>
      )}
      {showResult && (
        <div className="text-center">
          <div className="w-[926px] text-center justify-center text-neutral-900 text-5xl font-medium font-['Bitter']">{t('emailUnsubscribe.resultTitle')}</div>
          <div className="mt-3 text-center justify-center text-neutral-500 text-xl font-normal font-['DM_Sans'] leading-loose">{t('emailUnsubscribe.resultDesc')}</div>
        </div>
      )}
    </div>
  );
}
